module.exports = __webpack_public_path__ + "img/jiaoyu_xibeinonglin.079bf1b8.png";